import { FormattedFollowUpTask } from '~/components/FollowUpTask'
import { getFlag } from '~/hooks/useFlag'
import { Include, ScheduledSurgery, Surgery, SurgeryFolderMetadatum, UnScheduledSurgery } from '~/storm'

import { isScheduledSurgery, isSurgeryLetterSent } from './dips'

type SurgeryWithFolderMetadata = Include<ScheduledSurgery | UnScheduledSurgery, { surgeryFolderMetadata: true }>

function hasFolderMetadata(surgery: Surgery): surgery is SurgeryWithFolderMetadata {
    return 'surgeryFolderMetadata' in surgery && surgery.surgeryFolderMetadata !== undefined
}

export function getSurgeryMetadata(surgery: Surgery): SurgeryFolderMetadatum | undefined {
    return hasFolderMetadata(surgery) ? surgery.surgeryFolderMetadata : undefined
}

export function selfDeclarationFormNeedsFollowUp(_surgery: Surgery) {
    return getFlag('surgery_metadata__follow_up_self_declaration_form') && Boolean(getSurgeryMetadata(_surgery)?.self_declaration_form)
}
export function externalDocumentNeedsFollowUp(_surgery: Surgery) {
    return getFlag('surgery_metadata__follow_up_external_document') && Boolean(getSurgeryMetadata(_surgery)?.external_document)
}
export function testResultsNeedsFollowUp(_surgery: Surgery) {
    return getFlag('surgery_metadata__follow_up_test_results') && Boolean(getSurgeryMetadata(_surgery)?.test_results)
}
export function letterNotSent(surgery: Surgery) {
    return getFlag('dips__booking_letter_status') && isScheduledSurgery(surgery) && !isSurgeryLetterSent(surgery)
}
export function formatFollowUpTasks(surgery: Surgery): FormattedFollowUpTask[] {
    const tasks: FormattedFollowUpTask[] = []

    if (letterNotSent(surgery)) tasks.push('brev ikke sendt')
    if (externalDocumentNeedsFollowUp(surgery)) tasks.push('eksternt dokument')
    if (selfDeclarationFormNeedsFollowUp(surgery)) tasks.push('egenerklæringsskjema')
    if (testResultsNeedsFollowUp(surgery)) tasks.push('prøvesvar')

    return tasks
}
